import React from 'react';
import { MapPin, Building, Clock } from 'lucide-react';
export function FeaturedJobs() {
  const featuredJobs = [{
    id: 1,
    title: 'Executive Chef',
    company: 'Grand Hotel & Resort',
    location: 'New York, NY',
    type: 'Full-time',
    logo: 'https://images.unsplash.com/photo-1551009175-15bdf9dcb580?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&h=200&q=80'
  }, {
    id: 2,
    title: 'Pastry Chef',
    company: 'Sweet Delights Bakery',
    location: 'Chicago, IL',
    type: 'Full-time',
    logo: 'https://images.unsplash.com/photo-1563729784474-d77dbb933a9e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&h=200&q=80'
  }, {
    id: 3,
    title: 'Catering Server',
    company: 'Elite Events Catering',
    location: 'Los Angeles, CA',
    type: 'Part-time',
    logo: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&h=200&q=80'
  }, {
    id: 4,
    title: 'Sous Chef',
    company: 'Riverside Restaurant',
    location: 'Austin, TX',
    type: 'Full-time',
    logo: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&h=200&q=80'
  }];
  return <section className="py-16 bg-white" data-id="element-77">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-78">
        <div className="text-center mb-12" data-id="element-79">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-80">Featured Jobs</h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-81">
            Discover the latest opportunities in the catering industry
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-82">
          {featuredJobs.map(job => <div key={job.id} className="border border-gray-200 rounded-lg p-6 hover:shadow-lg transition bg-white" data-id="element-83">
              <div className="flex items-center mb-4" data-id="element-84">
                <img src={job.logo} alt={job.company} className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-85" />
                <h3 className="font-semibold text-lg text-gray-900" data-id="element-86">
                  {job.title}
                </h3>
              </div>
              <div className="space-y-2 mb-4" data-id="element-87">
                <div className="flex items-center text-gray-600" data-id="element-88">
                  <Building size={16} className="mr-2 text-gray-400" data-id="element-89" />
                  <span data-id="element-90">{job.company}</span>
                </div>
                <div className="flex items-center text-gray-600" data-id="element-91">
                  <MapPin size={16} className="mr-2 text-gray-400" data-id="element-92" />
                  <span data-id="element-93">{job.location}</span>
                </div>
                <div className="flex items-center text-gray-600" data-id="element-94">
                  <Clock size={16} className="mr-2 text-gray-400" data-id="element-95" />
                  <span data-id="element-96">{job.type}</span>
                </div>
              </div>
              <a href="#" className="block text-center bg-white border border-amber-600 text-amber-600 px-4 py-2 rounded hover:bg-amber-50 transition mt-4" data-id="element-97">
                View Details
              </a>
            </div>)}
        </div>
        <div className="mt-12 text-center" data-id="element-98">
          <a href="#" className="inline-block bg-amber-600 text-white px-6 py-3 rounded-md hover:bg-amber-700 transition font-medium" data-id="element-99">
            Browse All Jobs
          </a>
        </div>
      </div>
    </section>;
}